export const secondsPerMinute = 60;
export const secondsPerHour = 60 * secondsPerMinute;
export const secondsPerDay = 24 * secondsPerHour;

// How much run-up a countdown bar's fill represents: empty at a month out,
// full on arrival. This used to be a full year, and against a year everything
// actually on screen sat between 92% and 99% full - five bars that all looked
// like the same solid slab, so the biggest visual channel on the row carried
// no information at all. Thirty days is roughly the horizon these events live
// on, which makes the fill readable at a glance: half full is a fortnight out,
// a sliver is next month, and solid genuinely means imminent.
export const countdownHorizonSeconds = 30 * secondsPerDay;
